import React, { useEffect, useState } from "react";
import "./ChatbotSectionStyle.css";
import FiltersComponent from "../FiltersComponents/FiltersComponent";
import FinalChatBotView from "../chatBot/FinalChatBotView";
function ChatbotSection() {
  const [isChatbotVisible, setIsChatbotVisible] = useState(false);
  const [isChatbotLoading] = useState(false); // Loader state
  const [hasFocusedOnce, setHasFocusedOnce] = useState(false); // Track if focus has happened


  const adjustFormAndWidget = () => {
    const form = document.querySelector(".styles_footerBox__bPpNb");
    const textarea = form?.querySelector("textarea");
    const outerChatbotContainer = document.querySelector(
      ".chatbotOuterContainer"
    );

    if (form && textarea && !hasFocusedOnce) {
      if (!isChatbotVisible) {
        outerChatbotContainer.style.minHeight = "auto";
      }
      textarea.addEventListener("focus", () => {
        setIsChatbotVisible(true); // Switch to normal position on focus
        setHasFocusedOnce(true); // Prevent further focus triggers
        if (outerChatbotContainer) {
          outerChatbotContainer.style.minHeight = "110dvh";
          // Wait for the next render before scrolling
          setTimeout(() => {
            outerChatbotContainer.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }, 300);
        }
      });
    }
  };
  const enforceFormAdjustment = () => {
    // Continuously enforce the position every 500ms
    const interval = setInterval(() => {
      const form = document.querySelector(".styles_footerBox__bPpNb");
      if (form) {
        adjustFormAndWidget();
      }
    }, 500);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  };

  useEffect(() => {
    // initializeChatbot();

    // Wait for the chatbot to load, then adjust the form position
    const observer = new MutationObserver(() => {
      const form = document.querySelector(".styles_footerBox__HERzB");
      if (form) {
        adjustFormAndWidget();
        observer.disconnect(); // Stop observing once the form is found
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Enforce the adjustment as a fallback
    const cleanupEnforce = enforceFormAdjustment();

    return () => {
      observer.disconnect();
      cleanupEnforce();
    };
  }, [isChatbotVisible]); // Re-run the effect when the position state changes

  return (
    <div className="chatbotOuterContainer">
      <FiltersComponent />
      {isChatbotLoading && (
        <div className="loader-container">
          <div className="loader"></div>
          <p>Loading chatbot...</p>
        </div>
      )}
      <div id="aiiro-chat-bot-root">
        <FinalChatBotView />
      </div>
    </div>
  );
}

export default ChatbotSection;
